import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

const dark_theme = {
  development: {
    primary: '#FF9801', 
    background: colors.grey.darken3,
    color: '#FFFFFF'
  },
  staging: {
    primary: '#FF9801',
    background: colors.grey.darken3,
    color: '#FFFFFF'
  },
  preproduction: {
    primary: '#9C27B0',
    background: colors.grey.darken3,
    color: '#FFFFFF'
  },
  production: {
    primary: '#69BE29',
    background: colors.grey.darken3,
    color: '#FFFFFF'
  }
};

const light_theme = {
  development: {
    primary: '#69BE29',
  },
  staging: {
    primary: '#69BE29',    
  },
  preproduction: {
    primary: '#9C27B0'
  },
  production: {
    primary: '#69BE29'
  },
}

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    themes: { 
      dark: dark_theme[process.env.VUE_APP_ENV],
      light: light_theme[process.env.VUE_APP_ENV]
    },
    options: {
      customProperties: true,
    },
  },
});
